"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_STORAGE_OPTIONS = exports.CLIENT_EVENTS = exports.CLIENT_CONTEXT = void 0;
exports.CLIENT_CONTEXT = "client";
exports.CLIENT_EVENTS = {
    pairing: {
        proposal: "pairing_proposal",
        updated: "pairing_updated",
        created: "pairing_created",
        deleted: "pairing_deleted",
    },
    session: {
        proposal: "session_proposal",
        updated: "session_updated",
        created: "session_created",
        deleted: "session_deleted",
        notification: "session_notification",
        request: "session_request",
        response: "session_response",
    },
};
exports.CLIENT_STORAGE_OPTIONS = {
    database: ":memory:",
};
//# sourceMappingURL=client.js.map